import { StatusPill, type OrderStatus as PillStatus } from '@/components/ui/badge'

/**
 * Spec 07 · Status pills — admin.
 *
 * The shop has five order states; the spec draws four pills. Delivered
 * reads as a stronger "paid" (both are settled, both green) and
 * cancelled shares the destructive treatment with refunded, so the
 * table keeps a four-colour vocabulary instead of inventing a fifth.
 */
const PILL: Record<string, PillStatus> = {
  pending: 'pending',
  paid: 'paid',
  shipped: 'shipped',
  delivered: 'paid',
  cancelled: 'refunded',
  refunded: 'refunded',
}

export function OrderStatus({ status, label }: { status: string; label?: string }) {
  const text = label ?? status.charAt(0).toUpperCase() + status.slice(1)
  return <StatusPill status={PILL[status] ?? 'pending'}>{text}</StatusPill>
}
